import { combineReducers, Reducer } from 'redux';
import { i18nReducer, I18nState } from 'react-redux-i18n';
import { routerReducer, RouterState } from 'react-router-redux';
import { appInfos, AppInfosState } from '../containers/App/reducer';
import { galleryInfos, GalleryInfosState } from '../containers/Gallery/reducer';
import { authentication, AuthenticationState } from '../containers/Authentication/reducer';
import { driveList, DriveListState } from '../containers/DriveItemList/reducer';
import { newDriveItems, NewDriveItemState } from '../containers/DriveItemList/New/reducer';
import { search, SearchDriveItemState } from '../containers/DriveItemList/Search/reducer';
import { downloadManager, DownloadManagerState } from '../containers/DownloadManager/reducer';
import { notificationBar, NotificationBarState } from '../containers/NotificationBar/reducer';
import { multiAppAuthenticationInfos, MultiAppAuthenticationInfosState } from '../containers/MultiAppAuthentication/reducer';
import { favorites } from '../containers/Favorites/reducer';
import { offlineManager, OfflineManagerState } from '../containers/OfflineManager/reducer';
import { parametersPage, ParametersPageState } from '../containers/ParametersPage/reducer';
import { routerParamsHistory, RouterParamsState } from '../containers/SetRouteParams/reducer';
import { sharePanel, SharePanelState } from '../containers/Share/Panel/reducer';
import { menuManager, MenuState } from '../containers/MenuManager/reducer';
import { downloadAllPopup, DownloadAllPopupState } from '../containers/DownloadAllPopup/reducer';

export interface StoreState {
	appInfos: AppInfosState;
	authentication: AuthenticationState;
	downloadManager: DownloadManagerState;
	driveList: DriveListState;
	favorites: number[];
	galleryInfos: GalleryInfosState;
	i18n: Reducer<I18nState>;
	menuManager: MenuState;
	multiAppAuthenticationInfos: MultiAppAuthenticationInfosState;
	newDriveItems: NewDriveItemState;
	notificationBar: NotificationBarState;
	offlineManager: OfflineManagerState;
	parametersPage: ParametersPageState;
	routerParamsHistory: RouterParamsState[];
	routing: RouterState;
	search: SearchDriveItemState;
	sharePanel: SharePanelState;
	downloadAllPopup: DownloadAllPopupState;
}

const rootReducer = combineReducers<StoreState>({
	appInfos,
	authentication,
	downloadManager,
	driveList,
	favorites,
	galleryInfos,
	i18n: i18nReducer,
	menuManager,
	multiAppAuthenticationInfos,
	newDriveItems,
	notificationBar,
	offlineManager,
	parametersPage,
	routerParamsHistory,
	routing: routerReducer,
	search,
	sharePanel,
	downloadAllPopup
});

export default rootReducer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/index.ts